import { getWarehouses, getObjectsState, selectWarehouses, selectWarehouseStatus } from 'containers/Warehouses/warehousesSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useReduxSelector, useReduxDispatch } from 'store'
import { useEffect } from 'react'

const useWarehouses = (withState = false) => {
  const status = useReduxSelector(selectWarehouseStatus)
  const warehouses = useReduxSelector(selectWarehouses)
  const clientId = useReduxSelector(selectUserId)
  const dispatch = useReduxDispatch()

  useEffect(() => {
    if (clientId && (status === 'idle' || status === 'failed')) {
      dispatch(getWarehouses(clientId))
    }
  }, [clientId, dispatch, status])

  useEffect(() => {
    if (clientId && withState) {
      dispatch(getObjectsState())
    }
  }, [clientId, dispatch, withState])

  return warehouses
}

export default useWarehouses